import React from 'react'
import { Link } from 'react-router-dom'
import BackIcon from '../../../../../assets/icons/back'
import './index.scss'
import { useTranslation } from 'react-i18next'

export const Header = ({redirectLink, heading}: {redirectLink: string, heading: string}) => {
  const { t } = useTranslation()
  return (
    <header>
      <div className='header-content-wrapper wrapper'>
        <Link className='back' to={redirectLink} role='link' aria-label={String(t('HEADER.BACK'))}>
          <BackIcon />
        </Link>
        <h1 role='heading'>{heading}</h1>
      </div>
    </header>
  )
}
